export default __webpack_public_path__ + "static/media/DOM-SEPT-2024.909157a7.png";